export default import.meta.ROLLDOWN_FILE_URL_UOxjPJfeiv2CYz4lfG7uAw